export const TEST_ATTRIBUTE_KEY = 'data-testid';

export const addTestAttribute = (testId: string) => ({
  [TEST_ATTRIBUTE_KEY]: testId,
});
